// extracted by mini-css-extract-plugin
export default {"statusInfo":"styles_statusInfo__-danp","title":"styles_title__TE4eC","statusTitle":"styles_statusTitle__kLXfz","line":"styles_line__1cDCX"};